/* eslint-disable import-x/order */
import './set-webpack-path';
import 'util/Globals';

import {markInitialImportFinished} from 'util/StartImportTracker';
import markPageInitFinished from 'util/markPageInitFinished';

// MainRunner (and through it client/App.ts) is imported before RouterModelHub on purpose: it pulls in the
// shared app module graph, and importing it first makes this entry point evaluate that graph in the same
// order as the app and admin entry points. Several shared modules are part of import cycles that only
// initialize correctly in that order.
import mainRunner, {hotReload} from './util/MainRunner';
import ModelHubRouter from './RouterModelHub';

markInitialImportFinished();

if (process.env.NODE_ENV === 'development') {
  // Production build will skip this if block, preventing devInit from being bundled.
  const devInit = require('dev/devInit').default;
  devInit();
}

mainRunner([ModelHubRouter]);

// webpack HMR
if (module.hot) {
  module.hot.accept(['./RouterModelHub'], () => {
    const NextModelHubRouter = require('./RouterModelHub').default;
    hotReload([NextModelHubRouter]);
  });
}

markPageInitFinished();
